import { ExamDurationSessionType } from '@exam-center/graphql';

import { type ExamCourse } from '../../constants/types';

type ExamDuration = ExamCourse['settings']['examDuration'];

export function checkAddSessionCondition(
  multipleSessions: { value?: number }[],
  minSession: number,
  maxSession: number,
) {
  if (multipleSessions.length <= minSession) {
    return !multipleSessions.some((field) => field.value === undefined);
  }

  return multipleSessions.length < maxSession;
}

function mapExamDurationTypeToFormData(type: ExamDurationSessionType | undefined) {
  switch (type) {
    case ExamDurationSessionType.Single:
      return 'single-session';
    case ExamDurationSessionType.Multiple:
      return 'multiple-session';
    default:
      return undefined;
  }
}

function mapSingleSessionValueToFormData(examDuration: ExamDuration | undefined) {
  if (examDuration && examDuration.type === ExamDurationSessionType.Single) {
    // NOTE: define new const to avoid JS runtime error (freezing array), so we can't directly pop it.
    const singleSession = examDuration.sessions[examDuration.sessions.length - 1];
    return singleSession.value;
  } else {
    return undefined;
  }
}

function mapMultipleSessionValueToFormData(examDuration: ExamDuration | undefined) {
  if (examDuration && examDuration.type === ExamDurationSessionType.Multiple) {
    return examDuration.sessions.map((session) => ({ value: session.value }));
  } else {
    // Default value for multiple session, least 2 session fields will be rendered in the form
    return [{ value: undefined }, { value: undefined }];
  }
}

export function mapExamCourseSettingsToPreExamSettingsFormData(
  examCourseSettings: ExamDuration | null | undefined,
) {
  return {
    examDuration: {
      type: mapExamDurationTypeToFormData(examCourseSettings?.type),
      singleSessionValue: mapSingleSessionValueToFormData(examCourseSettings),
      multipleSessionValue: mapMultipleSessionValueToFormData(examCourseSettings),
    },
  } as const;
}
